//commands to execute in visual studios
//in backend folder type --> node index.js 
// npx react-scripts start                                                                 

import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./components/LoginPage";
import SignupPage from "./components/SignupPage";
import DepositorDashboard from "./components/Depositor/DepositorDashboard";
import AdminDashboard from "./components/Admin/AdminDashboard";
import { NotificationProvider } from "./components/Admin/NotificationContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HistoryProvider } from "./contexts/HistoryContext";
import ForgotPassword from "./components/ForgotPassword";
import { useAuth } from "./contexts/AuthContext";
import CustomersTable from "./components/Admin/CustomersTable";
import Footer from "./components/Footer";

// PrivateRoute wrapper
const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loadingUser } = useAuth();
  // sessionStorage restoration happens in a useEffect, so `user` is still
  // null on the very first render after a page reload — wait for that to
  // resolve before deciding to redirect, otherwise every reload on a
  // private route (e.g. /admin?product=123) briefly bounces to "/" and
  // loses the URL (query params included) before the real user loads.
  if (loadingUser) return null;
  if (!user) return <Navigate to="/" replace />;
  if (!allowedRoles.includes(user.role)) {
    return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
  }
  return children;
};

// Redirect if logged in
const RedirectIfLoggedIn = ({ children }) => {
  const { user, loadingUser } = useAuth();
  if (loadingUser) return null;
  if (!user) return children;
  return <Navigate to={user.role === "admin" ? "/admin" : "/dashboard"} replace />;
};

function App() {
  return (
    <HistoryProvider>
      <NotificationProvider>
        <ToastContainer
            position="top-right"
            autoClose={3000} hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
            limit={3}
            theme="colored" />
         <Router>
          <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<RedirectIfLoggedIn><LoginPage /></RedirectIfLoggedIn>} />
                <Route path="/signup" element={<SignupPage />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/dashboard" element={<PrivateRoute allowedRoles={["depositor"]}><DepositorDashboard /></PrivateRoute>} />
                <Route path="/admin" element={<PrivateRoute allowedRoles={["admin"]}><AdminDashboard /></PrivateRoute>} />
                <Route path="/admin/customers" element={<PrivateRoute allowedRoles={["admin"]}><CustomersTable /></PrivateRoute>} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </Router>
      </NotificationProvider>
    </HistoryProvider>
  );
}

export default App;